import { DepositAccountDataState } from '@banking/ui/workflows/card-settings';
import { ControlType } from '@banking/ui/components/banking/checking/card-settings/management/setting';
import assert from '@banking/ui/utils/assert';
import { Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { windowMocks } from '@square/dashboard-utilities/utils/window';
const BANKING_ACCOUNT_OWNERSHIP_LETTER_URL = '/v3/bank-accounts/legal/account-ownership-letter';
const STATEMENTS_RETURN_TO = 'banking.card-settings';
export const getStatementsSetting = (t, cardToken, unitToken, transitionTo) => () => {
  return {
    icon: '24px-bar-graph',
    text: t('banking.checking.cardSettings.page.settings.statements'),
    control: {
      type: ControlType.Regular,
      action: () => transitionTo('statements', {
        queryParams: {
          cardToken,
          unitToken,
          returnTo: STATEMENTS_RETURN_TO
        }
      })
    }
  };
};
export const getAccountOwnershipLetterSetting = (t, unitToken) => () => {
  return {
    icon: 'download-file',
    text: t('banking.checking.cardSettings.page.settings.downloadOwnershipLetter'),
    control: {
      type: ControlType.Regular,
      action: () => {
        windowMocks.open(`${BANKING_ACCOUNT_OWNERSHIP_LETTER_URL}?unit_token=${unitToken}`);
      }
    }
  };
};
export const getDocumentSettings = (t, canAccessStatements, cardToken, unitToken, transitionTo) => state => {
  if (state.loading || !canAccessStatements) {
    return [];
  }
  assert(state.card != null);
  if (!state.card.relationship.includes(Relationship.RELATIONSHIP_ACCOUNT_HOLDER) || !state.card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER)) {
    return [];
  }
  const settings = [getStatementsSetting(t, cardToken, unitToken, transitionTo)()];
  if (state.depositAccountData === DepositAccountDataState.HAS_DEPOSIT_ACCOUNT) {
    settings.push(getAccountOwnershipLetterSetting(t, unitToken)());
  }
  return settings;
};